let env = process.env.NEXT_PUBLIC_ENV

const getBaseUrl = () => {
    let envList = ["local", "dev", "prod"]
    let url = {
        local: process.env.NEXT_PUBLIC_ROOT_LOCAL_URL,
        dev: process.env.NEXT_PUBLIC_ROOT_DEV_URL,
        prod: process.env.NEXT_PUBLIC_ROOT_PROD_URL
    }

    return envList?.includes(env) ? url[env] : url?.prod
}

const getPreviewBaseUrl = () => {
    let envList = ["local", "dev", "prod"]
    let url = {
        local: process.env.NEXT_PUBLIC_PREVIEW_ROOT_LOCAL_URL,
        dev: process.env.NEXT_PUBLIC_PREVIEW_ROOT_DEV_URL,
        prod: process.env.NEXT_PUBLIC_PREVIEW_ROOT_PROD_URL
    }

    return envList?.includes(env) ? url[env] : url?.prod
}

export const rootUrl = getBaseUrl()
export const previewRootUrl = getPreviewBaseUrl()
export const accessToken = process.env.NEXT_PUBLIC_ACCESS_TOKEN

export const sortConfig = {
    sortBy: "published_at",
    sortOrder: "desc"
}